import { NavLink, useLocation } from 'react-router-dom'
import './Sidebar.css'

const moduleRoutes = [
  {
    name: 'Overview',
    path: '/dashboard',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7" rx="1"/>
        <rect x="14" y="3" width="7" height="7" rx="1"/>
        <rect x="3" y="14" width="7" height="7" rx="1"/>
        <rect x="14" y="14" width="7" height="7" rx="1"/>
      </svg>
    ),
    end: true
  },
  {
    name: 'Studio',
    subtitle: 'AI App Builder',
    path: '/dashboard/studio',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2"/>
        <path d="M3 9h18"/>
        <path d="M9 21V9"/>
      </svg>
    ),
    color: 'studio',
    active: true,
    children: [
      { name: 'Projects', path: '/dashboard/studio/projects' },
      { name: 'Editor', path: '/dashboard/studio/editor' },
      { name: 'Domains', path: '/dashboard/studio/domains' },
      { name: 'Analytics', path: '/dashboard/studio/analytics' }
    ]
  },
  {
    name: 'Payments',
    subtitle: 'Chekkouts',
    path: '/dashboard/payments',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="1" y="4" width="22" height="16" rx="2"/>
        <line x1="1" y1="10" x2="23" y2="10"/>
      </svg>
    ),
    color: 'payments',
    active: true,
    children: [
      { name: 'Transactions', path: '/dashboard/payments/transactions' },
      { name: 'Checkouts', path: '/dashboard/payments/checkouts' },
      { name: 'Payouts', path: '/dashboard/payments/payouts' },
      { name: 'Customers', path: '/dashboard/payments/customers' }
    ]
  },
  {
    name: 'Accounting',
    subtitle: 'Keeply',
    path: '/dashboard/accounting',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
        <line x1="8" y1="7" x2="16" y2="7"/>
        <line x1="8" y1="11" x2="16" y2="11"/>
        <line x1="8" y1="15" x2="12" y2="15"/>
      </svg>
    ),
    color: 'accounting',
    active: true,
    children: [
      { name: 'Dashboard', path: '/dashboard/accounting' },
      { name: 'Transactions', path: '/dashboard/accounting/transactions' },
      { name: 'Reports', path: '/dashboard/accounting/reports' },
      { name: 'Tax', path: '/dashboard/accounting/tax' }
    ]
  },
  {
    name: 'Chat & Support',
    subtitle: 'Relay',
    path: '/dashboard/relay',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
      </svg>
    ),
    color: 'relay',
    active: false,
    children: [
      { name: 'Inbox', path: '/dashboard/relay/inbox' },
      { name: 'Widgets', path: '/dashboard/relay/widgets' },
      { name: 'Contacts', path: '/dashboard/relay/contacts' },
      { name: 'Automations', path: '/dashboard/relay/automations' }
    ]
  },
  {
    name: 'HR & Payroll',
    subtitle: 'People',
    path: '/dashboard/people',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
    color: 'people',
    active: false,
    children: [
      { name: 'Employees', path: '/dashboard/people/employees' },
      { name: 'Payroll', path: '/dashboard/people/payroll' },
      { name: 'Time Off', path: '/dashboard/people/time-off' },
      { name: 'Documents', path: '/dashboard/people/documents' }
    ]
  },
  {
    name: 'Infrastructure',
    subtitle: 'Namelyft',
    path: '/dashboard/infrastructure',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="2" width="20" height="8" rx="2"/>
        <rect x="2" y="14" width="20" height="8" rx="2"/>
        <line x1="6" y1="6" x2="6.01" y2="6"/>
        <line x1="6" y1="18" x2="6.01" y2="18"/>
      </svg>
    ),
    color: 'infrastructure',
    active: false,
    children: [
      { name: 'Projects', path: '/dashboard/infrastructure/projects' },
      { name: 'Domains', path: '/dashboard/infrastructure/domains' },
      { name: 'Deployments', path: '/dashboard/infrastructure/deployments' },
      { name: 'Usage', path: '/dashboard/infrastructure/usage' }
    ]
  }
]

const accountRoutes = [
  {
    name: 'Billing',
    path: '/dashboard/billing',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="1" x2="12" y2="23"/>
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
      </svg>
    )
  },
  {
    name: 'Team',
    path: '/dashboard/team',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    )
  },
  {
    name: 'Settings',
    path: '/dashboard/settings',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3"/>
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
      </svg>
    )
  }
]

function Sidebar({ collapsed, mobileOpen, onMobileClose }) {
  const location = useLocation()
  
  const isModuleActive = (route) => {
    return location.pathname.startsWith(route.path)
  }

  return (
    <aside className={`sidebar ${collapsed ? 'collapsed' : ''} ${mobileOpen ? 'mobile-open' : ''}`}>
      {/* Logo */}
      <div className="sidebar-header">
        <NavLink to="/dashboard" className="sidebar-logo">
          <div className="logo-icon">
            <svg width="28" height="28" viewBox="0 0 32 32" fill="none">
              <defs>
                <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#7C3AED"/>
                  <stop offset="50%" stopColor="#2563EB"/>
                  <stop offset="100%" stopColor="#06B6D4"/>
                </linearGradient>
              </defs>
              <rect width="32" height="32" rx="8" fill="url(#logoGradient)"/>
              <path d="M10 12h4v8h-4v-8zm8 0h4v8h-4v-8z" fill="white"/>
              <path d="M10 10h12v2H10v-2zm0 10h12v2H10v-2z" fill="white" opacity="0.8"/>
            </svg>
          </div>
          {!collapsed && <span className="logo-text">Hubthrill</span>}
        </NavLink>
        
        {/* Mobile close button */}
        <button className="mobile-close" onClick={onMobileClose} aria-label="Close menu">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>

      {/* Navigation */}
      <nav className="sidebar-nav">
        {/* Modules Section */}
        <div className="nav-section">
          {!collapsed && <span className="nav-section-title">Modules</span>}
          <ul className="nav-list">
            {moduleRoutes.map((route) => (
              <li key={route.path} className={`nav-item ${route.color || ''}`}>
                <NavLink 
                  to={route.path} 
                  end={route.end}
                  className={({ isActive }) => 
                    `nav-link ${isActive ? 'active' : ''} ${!route.active && route.active !== undefined ? 'inactive' : ''}`
                  }
                  title={collapsed ? route.name : undefined}
                >
                  <span className="nav-icon">{route.icon}</span>
                  {!collapsed && (
                    <span className="nav-text">
                      <span className="nav-name">{route.name}</span>
                      {route.subtitle && <span className="nav-subtitle">{route.subtitle}</span>}
                    </span>
                  )}
                  {!route.active && route.active !== undefined && !collapsed && (
                    <span className="nav-badge inactive">Inactive</span>
                  )}
                </NavLink>
                
                {/* Sub-navigation */}
                {route.children && !collapsed && isModuleActive(route) && (
                  <ul className="nav-sub-list">
                    {route.children.map((child) => (
                      <li key={child.path}>
                        <NavLink 
                          to={child.path} 
                          className={({ isActive }) => `nav-sub-link ${isActive ? 'active' : ''}`}
                        >
                          {child.name}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* Account Section */}
        <div className="nav-section">
          {!collapsed && <span className="nav-section-title">Account</span>}
          <ul className="nav-list">
            {accountRoutes.map((route) => (
              <li key={route.path} className="nav-item">
                <NavLink 
                  to={route.path}
                  className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                  title={collapsed ? route.name : undefined}
                >
                  <span className="nav-icon">{route.icon}</span>
                  {!collapsed && <span className="nav-text">{route.name}</span>}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </nav>

      {/* User info at bottom */}
      {!collapsed && (
        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">SC</div>
            <div className="user-details">
              <span className="user-name">Sarah Chen</span>
              <span className="user-company">Acme Corp</span>
            </div>
          </div>
        </div>
      )}
    </aside>
  )
}

export default Sidebar
